import React, { useEffect } from 'react';
import { Loader } from 'semantic-ui-react';
import Button from 'components/button';
import styles from './styles/policyAddedScreen.scss';

const PolicyAddedScreen = ({
  next,
  showButton = true,
  text,
  showSpinner = false,
  resetPolicyForm,
}) => {
  useEffect(() => resetPolicyForm, []);

  return (
    <div className={styles.container}>
      <img
        className={styles.img}
        src="https://quashed.co.nz/images/q/q-folded-arms.svg"
      />
      <div className={styles.content}>{text}</div>
      {showButton && (
        <Button className={styles.greenBtn} text="Next" onClick={next} />
      )}
      {showSpinner && (
        <div className={styles.spinner}>
          <Loader size="medium" active={true} />
        </div>
      )}
    </div>
  );
};

export default PolicyAddedScreen;
